<script setup>
import translate from "@/filters/translate.filter"
import {
  DsStepper
} from "@ds/vue2"

const progress = -1
const steps = 3
</script>

<template>
  <DsStepper :progress="progress" :steps="steps">
    <template v-slot:step-1>
      <div class="body-500" v-html="translate('goldkid-stepperAB:step-2')" />
      <div class="body-300 text-text-secondary" v-html="translate('goldkid-stepperAB:step-2-desc')" />
    </template>
    <template v-slot:step-2>
      <div class="body-500" v-html="translate('goldkid-stepperAB:step-3')" />
    </template>
    <template v-slot:step-3>
      <div class="body-500" v-html="translate('goldkid-stepperAB:step-4')" />
    </template>
  </DsStepper>
</template>